import {
  GET_OUTLET_STATUS_COUNTS,
  GET_OUTLET_STATUS_COUNTS_SUCCESS,
  GET_OUTLET_STATUS_COUNTS_ERROR,
  GET_OUTLET_STATUS_COUNTS_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetOutletStatusCounts = (state = initialState, action) => {
  switch (action.type) {
    case GET_OUTLET_STATUS_COUNTS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_OUTLET_STATUS_COUNTS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_OUTLET_STATUS_COUNTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_OUTLET_STATUS_COUNTS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetOutletStatusCounts;
